import React, { Component } from "react";
import { Container, Segment, Image } from "semantic-ui-react";
import { Link } from "react-router-dom";
import FibreReadyFooter from "./FibreReadyFooter";
import twitter from "../../semantic/dist/themes/fibrestream/assets/images/twitter.png";
import instagram from "../../semantic/dist/themes/fibrestream/assets/images/instagram.png";
import twitter2 from "../../semantic/dist/themes/fibrestream/assets/images/twitter2.png";
import instagram2 from "../../semantic/dist/themes/fibrestream/assets/images/instagram2.png";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getUrlParameters } from '../../util';
import { setGeoCity } from '../../store/actions/app';
import { getGeo } from '../../store/actions/geo';

class Footer extends Component {
  constructor(props) {
   super(props);
   this.state = {
     city: null
   }
  }

  componentDidMount() {
    const city = this.getCityFromQueryString() || this.props.geoCity || null;
    this.setState({ city: city });
    if (!city) {
      this.props.getGeo();
    }
  }

  getCityFromQueryString() {
    const params = getUrlParameters();
    const city = params["city"];
    if (city) {
      this.props.setGeoCity(city);
    }
    return city;
  }

  render() {
    const { footerType, footerFormType, promoData, geoCity } = this.props;
    const { city } = this.state;
    const selectedCity = city || geoCity || null;
    return (
      <footer>
        <Segment
          className={
            "vertical py-0 " + (footerType === "white" ? "white" : "inverted")
          }
        >
          <Container>
            {footerFormType === "signUpFooter" ? "" : <FibreReadyFooter />}
          </Container>
        </Segment>
        <Segment
          className={
            "vertical py-0 " + (footerType === "white" ? "default" : "inverted")
          }
        >
          <Container>
            <div className="ui two column stretched grid footer__links">
              <div className="ui column py-0">
                <div className="ui grid left aligned right floated my-0">
                  <div className="ui segment basic link list">
                    <Link className="item" to={"/support"}>
                      Support
                    </Link>
                    <Link to={"/faqs"} className="item">
                      FAQs
                    </Link>
                    <Link to={"/about"} className="item">
                      About
                    </Link>
                    <Link to={"/privacy"} className="item">
                      Privacy
                    </Link>
                    <a href="https://support.fibrestream.ca/article/npbq5us7h4-what-do-i-do-if-i-have-a-complaint" className="item">
                      Complaints
                    </a>
                    <Link to={"/press"} className="item">
                      Press
                    </Link>
                  </div>
                </div>
              </div>
              <div className="column right aligned py-0 pr-0">
                <div className="ui basic segment pt-0 social-media">
                  <Image
                    as="a"
                    href="https://www.instagram.com/fibrestream/"
                    target="_blank"
                    rel="noopener noreferrer"
                    src={footerType === "white" ? instagram2 : instagram}
                    alt=""
                  />
                  <Image
                    className="twitter-icon"
                    as="a"
                    href="https://twitter.com/fibrestream"
                    target="_blank"
                    rel="noopener noreferrer"
                    src={footerType === "white" ? twitter2 : twitter}
                    alt=""
                  />
                </div>
                <div className="ui segment basic bottom aligned grid mb-0">
                  { promoData &&
                      <div className="column text-grey pl-0 f-size--12" dangerouslySetInnerHTML={{__html: (promoData ? promoData.terms : null)}}>

                      </div>
                  }
                  { !promoData && selectedCity === 'British Columbia' &&
                      <div className="column text-grey pl-0 f-size--12">
                        * Current as of January 5, 2026 for a limited time.
                        Available to new FibreStream customers in select buildings only.
                        Cannot be combined with any other offers. Subject to change. Taxes extra.
                      </div>
                  }
                  { !promoData && selectedCity !== 'British Columbia' &&
                      <div className="column text-grey pl-0 f-size--12">
                        * Current as of January 5, 2026. Available to new FibreStream customers in select buildings only.
                        Cannot be combined with any other offers. Subject to change. Taxes extra.
                      </div>
                  }
                </div>
                <div className="ui segment basic bottom aligned grid mb-0">
                  <div className="column text-copyright pl-0 f-size--14">
                    &copy; FibreStream
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Segment>
      </footer>
    );
  }
}

const mapStateToProps = state => {
  return {
    geoCity: state.app.geoCity,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getGeo: () => dispatch(getGeo()),
    setGeoCity: (city) => dispatch(setGeoCity(city)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Footer)
);



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js